export const WARNING = 'warning';
export const SUCCESS = 'success';
export const DANGER = 'danger';
